/**
 * Created by fers on 05.02.16.
 */

import Link from 'react-router/lib/Link';
import * as Tool from './Tool';
import EmptyContent from '../view/box/system/EmptyContent.react';
import {injectIntl, IntlShape} from 'react-intl';
import {ParentBox} from '../view/box-utils/ParentBox.react';
import HeaderCell from './GridHeaderCell.react';
import Highlighter from "react-highlight-words";

import React from 'react';
import PropTypes from 'prop-types';

export const ASCENDING = 'ascending';
export const DESCENDING = 'descending';

interface GridProps {
 columns: any;
 firstLevelTypes?: boolean;
 getUrl?: (...args: unknown[]) => unknown;
 hoverEffect?: boolean;
 intl?: object;
 list: unknown[];
 metadata: object;
 noTitles?: boolean;
 render?: (...args: unknown[]) => unknown;
 renderLink?: boolean;
 urlMapping?: object;
}

export class Grid extends React.Component<GridProps> {
    static propTypes = {
        columns: PropTypes.any.isRequired,
        firstLevelTypes: PropTypes.bool,
        getUrl: PropTypes.func,
        hoverEffect: PropTypes.bool,
        intl: PropTypes.object,
        list: PropTypes.array.isRequired,
        metadata: PropTypes.object.isRequired,
        noTitles: PropTypes.bool,
        render: PropTypes.func,
        renderLink: PropTypes.bool,
        urlMapping: PropTypes.object,
    };

    static defaultProps = {
        getUrl: function (item, column) {
            if (column) {
                return;
            }

            const {urlMapping} = this.props;

            let primaryKey;
            let metadata = this.props.metadata;

            let primaryField = metadata.getPrimaryKey();
            if (primaryField) {
                primaryKey = primaryField.key;
            }

            if (urlMapping && primaryKey) {
                return urlMapping.getUrl(metadata, 'view', item);
            }
        },
        hoverEffect: true,
        noTitles: false,
        renderLink: true,
        firstLevelTypes: false,
    };

    static isEmpty = ParentBox.isEmpty;

    // eslint-disable-next-line max-params
    static getColumnsForMap(columns, fields, colArray, filterUndefinedColumns = true) {
        colArray = colArray || columns;
        let colObject = columns;

        if (Array.isArray(columns)) {
            colObject = {};
        }
        if (!Array.isArray(colArray)) {
            colArray = Object.keys(colArray);
        }

        if (filterUndefinedColumns) {
            colArray = colArray.filter(column => Tool.getMappingForColumn(column, fields) || colObject[column] && colObject[column].showAlways);
        }

        /*
         1. filter out missing columns
         2. create mapping struct
        */
        return colArray
            .map(column => {
                if (colObject[column] && colObject[column].withoutMapping) {
                    return {
                        id: column,
                        object: colObject[column] || {},
                        map: {},
                        metadata: [colObject[column]],
                        invalid: false
                    };
                }

                let columnMap = Tool.getMappingForColumn(column, fields);

                return {
                    id: column,
                    object: colObject[column] || {},
                    map: columnMap || {},
                    metadata: Tool.getMappingForColumnAsArray(column, fields, filterUndefinedColumns),
                    invalid: !Boolean(columnMap)
                };
            });
    }

    render() {
        const { list, columns, metadata } = this.props;

        let primaryKey;

        let primaryField = metadata.getPrimaryKey();
        if (primaryField) {
            primaryKey = primaryField.key;
        }

        let fields = {...metadata.fields(), ...metadata.relations()};

        let columnMap = Grid.getColumnsForMap(columns, fields);

        if (list.length === 0) {
            return (<div><EmptyContent></EmptyContent></div>);
        } else {

            return (
                <table className={"table table-striped" + (this.props.hoverEffect ? ' table-hover' : '')}>
                    {this.props.noTitles === false ?
                    <thead>
                        <tr>
                            {
                                columnMap.map(columnMap => {
                                    if (columnMap.object.header) {
                                        return (<HeaderCell columnObject={columnMap.object} content={columnMap.object.header} key={columnMap.id} />);
                                    }
                                    return (<HeaderCell column={columnMap.id} columnMetadata={columnMap.metadata} columnObject={columnMap.object} entity={metadata.entity()} firstLevelTypes={this.props.firstLevelTypes} key={columnMap.id} />);
                                })
                            }
                        </tr>
                    </thead>
                    : null}
                    <tbody>
                        {list.filter(Boolean).map((item, idx) => {
                            let rowUrl = this.props.getUrl.apply(this, [item]);

                            return (<tr key={primaryKey ? item[primaryKey] : idx}>
                                {
                                    columnMap.map(columnMap => {
                                        let isVisible = true;
                                        let column = columnMap.id;
                                        let columnMapping = columnMap.map;

                                        for (let m of columnMap.metadata) {
                                            if (m.visibility) {
                                                isVisible = isVisible && m.visibility(item);

                                                if (!isVisible) {
                                                    break;
                                                }
                                            }
                                        }

                                        let url = this.props.getUrl.apply(this, [item, column]);
                                        if (!url) {
                                            url = rowUrl;
                                        }

                                        let value;
                                        if (item[column]) {
                                            value = item[column];

                                            if ('search' in columnMap.object && columnMap.object.search && columnMap.object.search.length > 0) {
                                                value = (<Highlighter autoEscape highlightClassName="highlight" searchWords={[columnMap.object.search]} textToHighlight={value} />);
                                            }
                                        }

                                        let content;
                                        if ('rednerNew'  in columnMap.object) {
                                            content = columnMap.object.rednerNew({
                                                column: column,
                                                item: item,
                                                url: url,
                                                columnMapping: columnMapping,
                                                columnValue: value
                                            });
                                        } else if ('render' in columnMap.object) {
                                            content = columnMap.object.render(column, item, url, columnMapping, value);
                                        } else {
                                            content = Tool.tranformDataForView(metadata.entity(), columnMapping, this.props.intl.formatMessage, Tool.getDataForColumn(column, fields, item), true);
                                        }

                                        if (this.props.render) {
                                            content = this.props.render(content, column, item, url, columnMapping);
                                        }

                                        let columnClassName = '';
                                        if ('className' in columnMap.object) {
                                            columnClassName = columnMap.object.className;

                                            if (typeof columnClassName === 'function') {
                                                columnClassName = columnClassName(item);
                                            }
                                        }

                                        return (<td className={column.replace('.', '_') + " " + columnClassName} key={(primaryKey ? item[primaryKey] : idx) + "_" + column} style={columnMap.object.width ? {width: columnMap.object.width + '%'} : {}} >{
                                            columnMap.object.link === false ?
                                                content
                                                :
                                                url ? (
                                                    url.substr(0, 1) === "/" && this.props.renderLink === true ?
                                                        <Link
                                                            key={idx}
                                                            style={isVisible ? {} : {display: "none"}}
                                                            to={url}>{content}</Link>
                                                        :
                                                        <a
                                                            href={url}
                                                            style={isVisible ? {} : {display: "none"}}
                                                            target="_top"
                                                            >{content}</a>
                                                    )
                                                    :
                                                    (isVisible ? content : null)
                                            }
                                            </td>);
                                        }
                                    )
                                }
                            </tr>);
                        })}
                    </tbody>
                </table>
            );
        }
    }
}

export default injectIntl(Grid);
